module.exports = __webpack_public_path__ + "name=img/src/assets/projects/design/steaky.png?7de6f22e95e74cf03eab0a4f4bc7de38";